import React, { useEffect } from 'react'
import useDragAndDropContext from "../../partials/DragAndDrop/hooks/useDragAndDropContext";
import {DragSource, DropArea} from "../../partials/DragAndDrop/compound-components";

const UnplacedSources = (props) => {
    const {index, children, oneItemAtATime, className} = props
    const {customDragLayer, allowSort, dndProps, source, target, unplacedHolder, style, dispatch} = useDragAndDropContext()
    const [unplaced, targetStates, dragData, manager] = dndProps
    const unplacedData = dragData.mergeTargetStateWithData(targetStates)[index]

    function handleDrop () {
        const action = {type:'handleDrop', package:arguments}
        console.log("Being dropped in unplaced sources", action)

        dispatch(action)
    }
    function handleMove () {
        console.log("Do not dispatch move for Unplaced")
        return
        const action = {type:'handleMove', package:arguments}
        dispatch(action)        
    }

    return (<>
        {children}
        {<DropArea
            data={{dS:unplaced, aS:''}}
            target={unplacedHolder}
            className ={className}
            onDrop={(item) => handleDrop(undefined, item)} // should this be 'index' or 'zone'
            style={style}
          >
            {
              dragData.mergeSourceStateWithData(oneItemAtATime ? [unplaced[0]] : unplaced).map(item =>
                <DragSource
                  data={item}
                  key={item.k}
                  style={style}
                  source={source}
                  onMove={handleMove}
                />)
            }
          </DropArea>}
    </>)

}
export default UnplacedSources